import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Customize your own moderation rules", -1)
const _hoisted_4 = { class: "dialog-card mt-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"800px"} }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "Basic", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "control-label mt-4" }, "Apply this list to", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "Block rules", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "control-label" }, "Block words", -1)
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "control-label mt-3" }, "Block formats", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "control-label mt-3" }, "Action", -1)
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "dialog-actions" }

import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useDialogStore } from '@/stores/dialogs';
import { useBlockListsStore } from '@/stores/blocks';
import { useDataStore } from '@/stores/data';
import { copy } from '@/utils/vue'
import { useErrors } from '@/utils/use-errors';
import BusinessesSelector from '../BusinessesSelector.vue'
import VButton from '../VButton.vue';
import VInput from '../VInput.vue';
import VInputTags from '../VInputTags.vue';
import VRadio from '../VRadio.vue';
import VSwitch from '../VSwitch.vue';
import { useWordStatsStore } from '@/stores/word-stats';
import { scrollToError } from '@/utils/scroll-top';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateBlockListDialog',
  props: {
    items: null,
    template: null,
    item: null,
    word: null
  },
  setup(__props: any) {

const props = __props as { 
  items?: any[],
  template?: any,
  item?: any,
  word?: string
}



const blockListStore = useBlockListsStore()
const dataStore = useDataStore()

const selected = reactive<App.Assets>({ businesses: [], pages: [], ad_accounts: [] })
if (props.items) {
  for (let comment of props.items) {
    if (comment.group_id === 1) {
      selected.businesses!.push(comment.id)
    }
    if (comment.group_id === 2) {
      selected.pages?.push(comment.id)
    }
    if (comment.group_id === 3) {
      selected.ad_accounts?.push(comment.id)
    }
  }
}
watch(selected, () => {
  errors.items = null
})

const switches = {
  links: { label: "Links" },
  images: { label: "Images" },
  animated_images: { label: "Animated Images" },
  stickers: { label: "Stickers" },
  phone_numbers: { label: "Phone numbers" },
  emails: { label: "Emails" }
}
const values = reactive<{[key: string]: any}>({
  name: "",
  type_id: 1,
  action_id: 1,
  keys: [],
  ...Object.fromEntries(Object.entries(switches).map(i => [ i[0], false ]))
})

const dialogStore = useDialogStore()

const fillItems = (item: typeof props.item) => {
  if (item) {
    for (let key in switches) {
      values[key] = item[key]
    }
    copy(values, item, "name", "type_id", "action_id")
    values.keys = [ ...item.keys ]
    if (item === props.template) {
      values["name"] = item["name"] + " - Copy"
    } else {
      dataStore.fillSet(selected, item)
    }
  }

  if (props.word) {
    if (!values.keys.includes(props.word)) {
      values.keys.push(props.word)
    }
  }
}

fillItems(props.item || props.template)

onMounted(async () => {
  const _item = props.item || props.template
  if (_item) {
    const item = await blockListStore.requestBlockListInfo(_item.id)
    fillItems(item)
  }
})

const hasItems = computed(() => {
  return selected.businesses?.length || selected.pages?.length || selected.ad_accounts?.length
})

const parentRef = ref<HTMLDivElement>()
const wordStatsStore = useWordStatsStore()
const { errors, checkRequired } = useErrors(values)
const pending = ref(false)
const apply = async () => {
  try {
    if (!checkRequired([ "name" ])) return
    if (!hasItems.value) {
      errors["items"] = "Select at least one item"
      return
    }
    let hasSwitch = false
    for (let key in switches) {
      if (values[key]) hasSwitch = true
    }
    if ((!values["keys"] || values["keys"].length === 0) && !hasSwitch) {
      errors["keys"] = "Enter in at least one keyword or select block formats below"
      return
    }
    pending.value = true

    const _values = { 
      ...values, 
      business_ids: selected.businesses,
      page_ids: selected.pages, 
      ad_account_ids: selected.ad_accounts, 
    } as any

    if (props.item) {
      await blockListStore.editBlockList(props.item.id, _values)
    } else {
      await blockListStore.createBlockList(_values)
    }
    if (props.word) {
      wordStatsStore.reset()
      wordStatsStore.requestAll()
    }
    dialogStore.close()
  } catch(e) {
    pending.value = false
    console.error(e)
  } finally {
    scrollToError(parentRef.value?.parentElement, errors)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.item)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, "Edit the blocklist"))
      : (_openBlock(), _createElementBlock("h2", _hoisted_2, "Create New Blocklist")),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _createVNode(VInput, {
        modelValue: values.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((values.name) = $event)),
        label: "Name",
        error: _unref(errors).name,
        name: "name",
        placeholder: "Enter Blocklist name"
      }, null, 8, ["modelValue", "error"]),
      _hoisted_7,
      _createVNode(BusinessesSelector, {
        modelValue: selected,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
        error: _unref(errors).items,
        name: "items",
        showInstagrams: ""
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", {
      class: "dialog-card",
      ref_key: "parentRef",
      ref: parentRef
    }, [
      _hoisted_8,
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(VRadio, {
          modelValue: values.type_id,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((values.type_id) = $event)),
          value: 1,
          label: "Exact"
        }, null, 8, ["modelValue"]),
        _createVNode(VRadio, {
          modelValue: values.type_id,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((values.type_id) = $event)),
          value: 2,
          label: "Contain"
        }, null, 8, ["modelValue"]),
        _createVNode(VRadio, {
          modelValue: values.type_id,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((values.type_id) = $event)),
          value: 3,
          label: "Both"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(VInputTags, {
        modelValue: values.keys,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((values.keys) = $event)),
        "highlight-word": props.word,
        class: "mt-2",
        label: "Block words",
        error: _unref(errors).keys,
        placeholder: "Put keyword and press Enter ⏎"
      }, null, 8, ["modelValue", "highlight-word", "error"]),
      _hoisted_11,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(switches, (item, key) => {
        return _createVNode(VSwitch, {
          modelValue: values[key],
          "onUpdate:modelValue": ($event: any) => ((values[key]) = $event),
          value: key,
          label: item.label
        }, null, 8, ["modelValue", "onUpdate:modelValue", "value", "label"])
      }), 64)),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createVNode(VRadio, {
          modelValue: values.action_id,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((values.action_id) = $event)),
          value: 1,
          label: "Hide"
        }, null, 8, ["modelValue"]),
        _createVNode(VRadio, {
          modelValue: values.action_id,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((values.action_id) = $event)),
          value: 2,
          label: "Delete"
        }, null, 8, ["modelValue"])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(VButton, {
        disabled: pending.value,
        big: "",
        onClick: apply
      }, {
        default: _withCtx(() => [
          (props.item)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Save")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Create")
              ], 64))
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(VButton, {
        secondary: "",
        big: "",
        onClick: _unref(dialogStore).close
      }, {
        default: _withCtx(() => [
          _createTextVNode("Cancel")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}
}

})